import React from 'react';
import { useSelector } from 'react-redux';

// Returns a sorted array of unique node tags aggregated from both flow sources
export const useAllNodeTags = () => {
  const stateCleanRoomFlowNodes = useSelector(state => state.flow?.cleanRoomFlow?.flow?.nodes);

  const allNodeTags = React.useMemo(() => {
    const rawFlowNodes = stateCleanRoomFlowNodes || [];
    const tagSet = new Set();
    const collect = (n) => {
      const nTags = n?.tags ?? n?.node?.tags ?? n?.data?.tags ?? '';
      nTags.split(',').map(t => t.trim()).filter(Boolean).forEach(t => tagSet.add(t));
    };
    rawFlowNodes.forEach(collect);
    return Array.from(tagSet).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
  }, [stateCleanRoomFlowNodes]);

  return allNodeTags;
};

export default useAllNodeTags;


